import { ApiClient } from './api-client';

export const apiClient = new ApiClient();
